"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoardContainer = void 0;
var GameVars_1 = require("../../../GameVars");
var BoardCell_1 = require("./BoardCell");
var Item_1 = require("./Item");
var BoardManager_1 = require("../BoardManager");
var CakeCover_1 = require("./CakeCover");
var CoinLabel_1 = require("./CoinLabel");
var GameConstants_1 = require("../../../GameConstants");
var Carousel_1 = require("./Carousel");
var GemsEffect_1 = require("./GemsEffect");
var AudioManager_1 = require("../../../AudioManager");
var BoardContainer = /** @class */ (function (_super) {
    __extends(BoardContainer, _super);
    function BoardContainer(scene) {
        var _this = _super.call(this, scene) || this;
        BoardContainer.currentInstance = _this;
        BoardContainer.createCoinLabelsPool(_this.scene);
        _this.items = [];
        _this.cells = [];
        _this.cakeCovers = [];
        _this.f = 0;
        _this.f2 = 0;
        _this.selectedItem = null;
        _this.dropCell = null;
        _this.carousel = null;
        var i = GameVars_1.GameVars.getNumActiveCells() - 6;
        var positionAndScale;
        var f;
        if (GameVars_1.GameVars.isDesktop) {
            positionAndScale = GameConstants_1.GameConstants.BOARD_POSITION_AND_SCALE_DESKTOP[i];
            f = .54;
        }
        else {
            if (GameVars_1.GameVars.aspectRatio <= 1.3) {
                positionAndScale = GameConstants_1.GameConstants.BOARD_POSITION_AND_SCALE_TACTILE_1_3[i];
            }
            else if (GameVars_1.GameVars.aspectRatio <= 1.45) {
                positionAndScale = GameConstants_1.GameConstants.BOARD_POSITION_AND_SCALE_TACTILE_1_45[i];
            }
            else if (GameVars_1.GameVars.aspectRatio <= 1.75) {
                positionAndScale = GameConstants_1.GameConstants.BOARD_POSITION_AND_SCALE_TACTILE_1_75[i];
            }
            else if (GameVars_1.GameVars.aspectRatio <= 2.05) {
                positionAndScale = GameConstants_1.GameConstants.BOARD_POSITION_AND_SCALE_TACTILE_2[i];
            }
            else {
                positionAndScale = GameConstants_1.GameConstants.BOARD_POSITION_AND_SCALE_TACTILE[i];
            }
            f = .53;
        }
        _this.x = GameVars_1.GameVars.gameWidth / 2 + positionAndScale.dc * BoardCell_1.BoardCell.WIDTH * positionAndScale.s;
        _this.y = GameVars_1.GameVars.gameHeight * f + positionAndScale.dr * BoardCell_1.BoardCell.HEIGHT * positionAndScale.s * GameVars_1.GameVars.scaleY;
        _this.setScale(positionAndScale.s, positionAndScale.s * GameVars_1.GameVars.scaleY);
        var boardConfiguration = GameVars_1.GameVars.modeGameData.boardConfiguration;
        for (var r = 0; r < boardConfiguration.length; r++) {
            var rowCells = boardConfiguration[r];
            for (var c = 0; c < rowCells.length; c++) {
                var cellData = rowCells[c];
                if (cellData.n !== -1) {
                    var cell = new BoardCell_1.BoardCell(_this.scene, { c: c, r: r });
                    cell.x = c * BoardCell_1.BoardCell.WIDTH;
                    cell.y = r * BoardCell_1.BoardCell.HEIGHT;
                    _this.add(cell);
                    cell.depth = cell.p.r;
                    _this.cells.push(cell);
                    if (cellData.n > 0) {
                        if (cellData.c !== 0) {
                            var cakeCover = new CakeCover_1.CakeCover(_this.scene, cell.p, cellData.c === 2, false, true);
                            _this.add(cakeCover);
                            _this.cakeCovers.push(cakeCover);
                        }
                        else {
                            var item = new Item_1.Item(_this.scene, cellData.n);
                            cell.addItem(item);
                            _this.items.push(item);
                        }
                    }
                }
            }
        }
        _this.labelsContainer = new Phaser.GameObjects.Container(_this.scene);
        _this.add(_this.labelsContainer);
        if (GameConstants_1.GameConstants.DEVELOPMENT) {
            var tmp = new Phaser.GameObjects.Graphics(_this.scene);
            _this.add(tmp);
            tmp.lineStyle(4, 0x000000);
            tmp.moveTo(0, 50);
            tmp.lineTo(0, -50);
            tmp.moveTo(-50, 0);
            tmp.lineTo(50, 0);
            tmp.stroke();
        }
        return _this;
    }
    BoardContainer.putBackCoinLabel = function (coinLabel) {
        BoardContainer.coinLabels.push(coinLabel);
    };
    BoardContainer.createCoinLabelsPool = function (scene) {
        BoardContainer.coinLabels = [];
        for (var i = 0; i < 10; i++) {
            var coinLabel = new CoinLabel_1.CoinLabel(scene);
            BoardContainer.coinLabels.push(coinLabel);
        }
    };
    BoardContainer.getCoinLabel = function (scene, n) {
        var coinLabel;
        if (BoardContainer.coinLabels.length > 0) {
            coinLabel = BoardContainer.coinLabels.pop();
        }
        else {
            coinLabel = new CoinLabel_1.CoinLabel(scene);
        }
        coinLabel.reset(n);
        return coinLabel;
    };
    BoardContainer.prototype.update = function () {
        if (GameVars_1.GameVars.paused && GameVars_1.GameVars.gameData.tutorialPhase !== 3) {
            return;
        }
        var selectedItem = null;
        this.items.forEach(function (item) {
            item.update();
            if (item.selected) {
                selectedItem = item;
            }
        });
        this.cells.forEach(function (cell) {
            cell.update();
        });
        if (this.carousel) {
            this.carousel.update();
        }
        ////// las tapas de los pasteles
        this.f++;
        if (this.f === 180) {
            this.f = 0;
            this.cakeCovers.forEach(function (cakeCover) {
                cakeCover.shake();
            });
        }
        ////// 
        if (selectedItem) {
            this.bringToTop(selectedItem);
            this.cells.forEach(function (cell) {
                cell.onItemOut();
            });
            for (var i = 0; i < this.cells.length; i++) {
                var cell = this.cells[i];
                if (this.checkCollision(cell, selectedItem)) {
                    cell.onItemOver();
                    break;
                }
            }
            if (selectedItem.i !== GameConstants_1.GameConstants.NUM_ITEMS) {
                // marcar las celdas que tengan un item igual
                this.cells.forEach(function (cell) {
                    if (cell.item && cell.item.i === selectedItem.i) {
                        cell.mark();
                    }
                });
            }
        }
        else {
            this.cells.forEach(function (cell) {
                cell.unmark();
            });
        }
        // las monedas
        this.f2++;
        if (this.f2 === 180) {
            this.f2 = 0;
        }
        this.emitCoins();
    };
    BoardContainer.prototype.addCell = function (p) {
        var i = GameVars_1.GameVars.getNumActiveCells() - 6;
        var positionAndScale;
        var f;
        if (GameVars_1.GameVars.isDesktop) {
            positionAndScale = GameConstants_1.GameConstants.BOARD_POSITION_AND_SCALE_DESKTOP[i];
            f = .54;
        }
        else {
            if (GameVars_1.GameVars.aspectRatio <= 1.3) {
                positionAndScale = GameConstants_1.GameConstants.BOARD_POSITION_AND_SCALE_TACTILE_1_3[i];
            }
            else if (GameVars_1.GameVars.aspectRatio <= 1.45) {
                positionAndScale = GameConstants_1.GameConstants.BOARD_POSITION_AND_SCALE_TACTILE_1_45[i];
            }
            else if (GameVars_1.GameVars.aspectRatio <= 1.75) {
                positionAndScale = GameConstants_1.GameConstants.BOARD_POSITION_AND_SCALE_TACTILE_1_75[i];
            }
            else if (GameVars_1.GameVars.aspectRatio <= 2.05) {
                positionAndScale = GameConstants_1.GameConstants.BOARD_POSITION_AND_SCALE_TACTILE_2[i];
            }
            else {
                positionAndScale = GameConstants_1.GameConstants.BOARD_POSITION_AND_SCALE_TACTILE[i];
            }
            f = .53;
        }
        this.scene.tweens.add({
            targets: this,
            x: GameVars_1.GameVars.gameWidth / 2 + positionAndScale.dc * BoardCell_1.BoardCell.WIDTH * positionAndScale.s,
            y: GameVars_1.GameVars.gameHeight * f + positionAndScale.dr * BoardCell_1.BoardCell.HEIGHT * positionAndScale.s * GameVars_1.GameVars.scaleY,
            scaleX: positionAndScale.s,
            scaleY: positionAndScale.s * GameVars_1.GameVars.scaleY,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 1450,
            delay: 450
        });
        var cell = new BoardCell_1.BoardCell(this.scene, { c: p.c, r: p.r }, true);
        cell.x = p.c * BoardCell_1.BoardCell.WIDTH;
        cell.y = p.r * BoardCell_1.BoardCell.HEIGHT;
        this.add(cell);
        this.cells.push(cell);
        this.sort("y");
        this.bringToTop(this.labelsContainer);
    };
    BoardContainer.prototype.spawnItem = function (p, isMisteryItem, itemPurchased) {
        var cakeCover = new CakeCover_1.CakeCover(this.scene, p, isMisteryItem, itemPurchased);
        this.add(cakeCover);
        this.cakeCovers.push(cakeCover);
    };
    BoardContainer.prototype.uncoverItem = function (p, isMysteriousItem, itemPurchased) {
        var i;
        for (i = 0; i < this.cakeCovers.length; i++) {
            if (this.cakeCovers[i].p === p) {
                break;
            }
        }
        var cakeCover = this.cakeCovers.splice(i, 1)[0];
        cakeCover.destroy();
        // añadimos el item
        var cell;
        for (i = 0; i < this.cells.length; i++) {
            if (this.cells[i].p.c === p.c && this.cells[i].p.r === p.r) {
                cell = this.cells[i];
                break;
            }
        }
        var item = new Item_1.Item(this.scene, GameVars_1.GameVars.modeGameData.boardConfiguration[p.r][p.c].n);
        cell.addItem(item);
        this.items.push(item);
        if (isMysteriousItem) {
            item.visible = false;
            this.carousel = new Carousel_1.Carousel(this.scene, cell.x, cell.y + BoardCell_1.BoardCell.ITEM_DELTA_Y);
            this.carousel.p = cell.p;
            this.add(this.carousel);
            AudioManager_1.AudioManager.playSound("surprise_cake_spin");
        }
        else {
            // el efecto
            var uncoverEffect_1 = new Phaser.GameObjects.Sprite(this.scene, cell.x, cell.y - 30, "texture_atlas_1", "fx_particles_radial_01");
            this.scene.add.existing(uncoverEffect_1);
            uncoverEffect_1.play("uncover-fx");
            this.add(uncoverEffect_1);
            uncoverEffect_1.on("animationcomplete", function () {
                uncoverEffect_1.destroy();
            });
            this.scene.tweens.add({
                targets: uncoverEffect_1,
                y: uncoverEffect_1.y - 80,
                scaleX: 1.35,
                scaleY: 1.35,
                ease: Phaser.Math.Easing.Cubic.Out,
                duration: 200,
                delay: 100
            });
        }
        if (itemPurchased) {
            BoardManager_1.BoardManager.needLevelUp(GameVars_1.GameVars.modeGameData.boardConfiguration[p.r][p.c].n);
        }
    };
    BoardContainer.prototype.onMysteriousItemDetermined = function (n) {
        this.carousel.destroy();
        this.carousel = null;
        for (var i = 0; i < this.items.length; i++) {
            if (this.items[i].cell.p.c === GameVars_1.GameVars.coverPosition.c && this.items[i].cell.p.r === GameVars_1.GameVars.coverPosition.r) {
                this.items[i].swapItem(n);
            }
            this.items[i].visible = true;
        }
    };
    BoardContainer.prototype.onMysteriousItemDeterminedPowerUp = function () {
        this.carousel.destroy();
        this.carousel = null;
        for (var i = 0; i < this.items.length; i++) {
            if (!this.items[i].visible) {
                this.items[i].visible = true;
                this.items[i].forceUpgrade();
                break;
            }
        }
    };
    BoardContainer.prototype.onItemPicked = function (item) {
        this.selectedItem = item;
        this.selectedItem.x += item.cell.x;
        this.selectedItem.y += item.cell.y;
        this.add(this.selectedItem);
        // this.selectedItem.cell.removeItem();
        // BoardManager.onItemPicked(this.selectedItem.cell.p);
    };
    BoardContainer.prototype.onItemReleased = function (item) {
        this.dropCell = null;
        for (var i = 0; i < this.cells.length; i++) {
            var cell = this.cells[i];
            if (this.checkCollision(cell, item)) {
                this.dropCell = cell;
                break;
            }
        }
        this.selectedItem.cell.removeItem();
        BoardManager_1.BoardManager.onItemPicked(this.selectedItem.cell.p);
        var goalCell = this.dropCell ? this.dropCell.p : null;
        BoardManager_1.BoardManager.onItemReleased(goalCell, item.cell.p, item.i);
    };
    BoardContainer.prototype.onItemsMerged = function () {
        var i = this.items.indexOf(this.selectedItem);
        this.items.splice(i, 1);
        this.selectedItem.destroy();
        this.selectedItem = null;
        this.dropCell.onItemsMerged();
        // el efecto que va al contenedor de las gema
        var startX = this.dropCell.x;
        var startY = this.dropCell.y - 30;
        var endX = (-this.x + GameVars_1.GameVars.gameWidth / 2 - 206) / this.scaleX;
        var endY = (-this.y + 115 * GameVars_1.GameVars.scaleY) / this.scaleY;
        var gemsEffect = new GemsEffect_1.GemsEffect(this.scene, startX, startY, endX, endY);
        this.add(gemsEffect);
        // el efecto de merge de los pasteles por encima del verde
        var glowImg = new Phaser.GameObjects.Image(this.scene, startX, startY, "texture_atlas_1", "radial2_new_cake_mistery_box");
        glowImg.blendMode = Phaser.BlendModes.SCREEN;
        glowImg.setScale(0);
        this.add(glowImg);
        this.scene.tweens.add({
            targets: glowImg,
            scaleX: 1.25,
            scaleY: 1.25,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 350,
            yoyo: true,
            onComplete: function () {
                glowImg.destroy();
            },
            onCompleteScope: this
        });
        // el efecto
        var mergeEffect = new Phaser.GameObjects.Sprite(this.scene, startX, startY, "texture_atlas_1", "fx_merge_01");
        this.scene.add.existing(mergeEffect);
        mergeEffect.play("merge-fx");
        mergeEffect.setScale(1.5);
        this.add(mergeEffect);
        mergeEffect.blendMode = Phaser.BlendModes.SCREEN;
        this.scene.time.delayedCall(300, function () {
            mergeEffect.setScale(1);
            this.scene.tweens.add({
                targets: mergeEffect,
                scaleX: 1.5,
                scaleY: 1.5,
                ease: Phaser.Math.Easing.Elastic.Out,
                duration: 1000,
                onComplete: function () {
                    mergeEffect.destroy();
                },
                onCompleteScope: this
            });
        }, [], this);
    };
    BoardContainer.prototype.dropSelectedItem = function () {
        this.dropCell.addItem(this.selectedItem);
        this.dropCell = null;
        this.selectedItem = null;
        AudioManager_1.AudioManager.playSound("click_button");
    };
    BoardContainer.prototype.returnItemToOrigin = function () {
        this.selectedItem.cell.addItem(this.selectedItem);
        this.selectedItem = null;
        this.cells.forEach(function (cell) {
            cell.onItemOut();
        });
        AudioManager_1.AudioManager.playSound("click_button");
    };
    BoardContainer.prototype.swapItems = function (cell1, cell2) {
        var item1 = this.getItemAt(cell1);
        var item2 = this.getItemAt(cell2);
        var i1 = item1.i;
        var i2 = item2.i;
        item1.swapItem(i2);
        item2.swapItem(i1);
    };
    BoardContainer.prototype.checkCollision = function (cell, item) {
        var ret = false;
        var cellRectX = cell.x - BoardCell_1.BoardCell.BOUNDING_BOX_WIDTH / 2;
        var cellRectY = cell.y - BoardCell_1.BoardCell.BOUNDING_BOX_HEIGHT / 2 + BoardCell_1.BoardCell.BOUNDING_BOX_Y;
        var cellRectWidth = BoardCell_1.BoardCell.BOUNDING_BOX_WIDTH;
        var cellRectHeight = BoardCell_1.BoardCell.BOUNDING_BOX_HEIGHT;
        if (item.x > cellRectX && item.x < cellRectX + cellRectWidth && item.y > cellRectY && item.y < cellRectY + cellRectHeight) {
            ret = true;
        }
        return ret;
    };
    BoardContainer.prototype.emitCoins = function () {
        for (var i = 0; i < this.items.length; i++) {
            var item = this.items[i];
            if (item.creationTick === this.f2 && !(this.carousel && item.cell.p.c === this.carousel.p.c && item.cell.p.r === this.carousel.p.r)) {
                var itemsCoinsPerSecond = GameVars_1.GameVars.itemCoinsPerSecond[item.i - 1] * (1 + GameVars_1.GameVars.modeGameData.restartCounter * .1);
                var coinLabel = BoardContainer.getCoinLabel(this.scene, itemsCoinsPerSecond);
                coinLabel.x = item.cell.x;
                coinLabel.y = item.cell.y - 30;
                coinLabel.animate();
                this.labelsContainer.add(coinLabel);
                item.onCoinsEmitted();
            }
        }
    };
    BoardContainer.prototype.getItemAt = function (cell) {
        var ret = null;
        for (var i = 0; i < this.items.length; i++) {
            var p = this.items[i].cell.p;
            if (cell.c === p.c && cell.r === p.r) {
                ret = this.items[i];
                break;
            }
        }
        return ret;
    };
    return BoardContainer;
}(Phaser.GameObjects.Container));
exports.BoardContainer = BoardContainer;
